import { playStimulusAudio } from '../../../../common/stimulus/stimulusButtonActions';
import { playAvatarAudio, setAvatarInstructions }
    from '../../../../common/avatar/avatarActions';
import {
    blockScreen, unblockScreen, activateNextButton, deactivateNextButton, greyOutScreen,
}
    from '../../../../common/screen/screenActions';
import { narrateStart } from '../../../../common/audio/audioActions';
import selectors from '../../../../rootSelectors';
import {
    highlightPossibleResponse, selectPossibleResponse, makeFirstAttempt,
    activateReadyForNextScreen,
} from '../../../../common/questions/questionsActions';
import { PRACTICE } from '../../../../constants/assessmentItemType';
import { RCT, ACCURACY } from '../../../../constants/measure';
import { goToCountdown } from '../../../../common/navigation/navigationActions';
import { GENERAL_AUDIO_DELAY } from '../../../../constants/time';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';

const ACCURACY_AUDIO = RCT_AUDIO_INSTRUCTIONS.ACCURACY;

export const handleOnNext = () => (dispatch, getStore) => {
    const state = getStore();
    if (!selectors.getQuestionsIsReadyForNextScreen(state)) {
        dispatch(blockScreen());
        dispatch(greyOutScreen());
        dispatch(deactivateNextButton());
        return Promise.resolve()
            .then(() => {
                const avatarAudioTracks = [ACCURACY_AUDIO.accuracyReadyInstruction];
                return dispatch(playAvatarAudio(avatarAudioTracks))
                    .then(() => {
                        dispatch(setAvatarInstructions(avatarAudioTracks));
                        dispatch(activateReadyForNextScreen());
                        dispatch(activateNextButton());
                        dispatch(unblockScreen());
                    });
            });
    }

    return Promise.resolve()
        .then(() => {
            dispatch(goToCountdown(RCT, ACCURACY));
        });
};

export const narrateScreen = (stimulusAudio, delay = GENERAL_AUDIO_DELAY) => (dispatch) => {
    dispatch(blockScreen());
    dispatch(narrateStart());
    return Promise.resolve()
        .then(() => dispatch(playAvatarAudio([ACCURACY_AUDIO.avatarStart]))
            .then(() => dispatch(playStimulusAudio([stimulusAudio], delay))
                .then(() => {
                    dispatch(unblockScreen());
                })));
};

const handleCorrectResponseSelected = (index) => (dispatch) => {
    dispatch(selectPossibleResponse(index));
    dispatch(blockScreen());
    return dispatch(playAvatarAudio([ACCURACY_AUDIO.correctResponseInstruction]))
        .then(() => {
            dispatch(setAvatarInstructions([ACCURACY_AUDIO.clickOk]));
            dispatch(activateNextButton());
            dispatch(unblockScreen());
        });
};

const handleFirstIncorrectResponseSelected = (stimulusAudio) => (dispatch) => {
    const avatarAudio = [ACCURACY_AUDIO.firstIncorrectInstruction];
    dispatch(blockScreen());
    dispatch(makeFirstAttempt());
    return dispatch(playAvatarAudio(avatarAudio))
        .then(() => dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY))
            .then(() => {
                dispatch(setAvatarInstructions(avatarAudio));
                dispatch(unblockScreen());
            }));
};

const handleSecondIncorrectResponseSelected = (correctResponseIndex) => (dispatch) => {
    dispatch(blockScreen());
    dispatch(highlightPossibleResponse(correctResponseIndex));
    return dispatch(playAvatarAudio([ACCURACY_AUDIO.secondIncorrectInstruction]))
        .then(() => {
            dispatch(setAvatarInstructions([ACCURACY_AUDIO.clickOk]));
            dispatch(activateNextButton());
            dispatch(unblockScreen());
        });
};

export const selectPracticeScreenResponse = (index) => (dispatch, getStore) => {
    const state = getStore();
    const isFirstAttemptMade = selectors.getIsFirstAttemptMade(state);
    const correctResponseIndex = selectors.getRCTAccuracyCorrectResponseIndex(state, PRACTICE);
    if (correctResponseIndex !== index) {
        if (!isFirstAttemptMade) {
            const stimulusAudio = selectors.getRCTAccuracyStimulusAudio(state, PRACTICE);
            return dispatch(handleFirstIncorrectResponseSelected(
                stimulusAudio,
            ));
        }

        return dispatch(handleSecondIncorrectResponseSelected(
            correctResponseIndex,
        ));
    }

    return dispatch(handleCorrectResponseSelected(index));
};
